export function insuranceTabPath(tab: string): string {
  return `/insurance?tab=${tab}`;
}

export function withReturnTo(path: string, returnTo: string): string {
  return `${path}${path.includes('?') ? '&' : '?'}returnTo=${encodeURIComponent(returnTo)}`;
}
